import _ from 'lodash'
import store from '@/store'
import Generator from './Generator'
import NavConfig from './modules/navigation/index'

const IDGenerator = new Generator()

class RenderData {
  constructor (tag, data = null, id = -1, index = 0, parent = null, children = null, skipMatch = false) {
    this.tag = tag
    if (id <= 0) {
      id = IDGenerator.nextValue()
    }
    this.id = id
    this.index = index
    this.data = data || {} // include props and on(eventHandlers)
    this.parent = parent
    this.children = children // this is a RenderData Array | Object with slot name
    this.skipMatch = skipMatch
  }

  toString () {
    return `
      id: ${this.id},
      index: ${this.index},
      tag: ${this.tag},
      data: ${this.data},
      parent: ${this.parent},
      children: ${this.children}`
  }

  toObject () {
    const obj = {}
    obj.id = this.id
    obj.index = this.index
    obj.tag = this.tag
    obj.data = _.cloneDeep(this.data)
    obj.skipMatch = this.skipMatch
    if (this.children) {
      obj.children = []
      _.forEach(this.children, item => {
        obj.children.push(item.toObject())
      })
    } else {
      obj.children = null
    }
    return obj
  }

  clone () {
    return _.cloneDeep(this)
  }

  static parseObject (obj, parentRenderData = null) {
    if (obj.id >= IDGenerator.current) {
      IDGenerator.reset(obj.id)
    }
    const renderData = new this(obj.tag, obj.data, obj.id, obj.index, parentRenderData, null, obj.skipMatch)
    if (obj.children) {
      renderData.children = []
      _.forEach(obj.children, item => {
        renderData.children.push(this.parseObject(item, renderData))
      })
    }
    return renderData
  }

  static createDefaultRootRenderData (pageData) {
    const isMobile = store.getters['microSite/isMobile']
    const classList = [
      'microsite-root'
    ]
    if (isMobile) {
      classList.push('mobile')
    }
    const renderData = new this('div', { props: { class: classList } }, -1, 0, null, [])
    const navigation = NavConfig.createRenderData(NavConfig.name, 0, renderData)
    if (pageData) {
      const pageNav = _.find(pageData.children, { tag: NavConfig.name })
      if (pageNav) {
        navigation.data.props.menus = pageNav.data.props.menus
      }
    }
    renderData.children.push(navigation)
    return renderData
  }
}

export default RenderData

export function resetIDGenerator (start, step) {
  IDGenerator.reset(start, step)
}
